export default __webpack_public_path__ + "static/media/allSet.bb87f33f.svg";